/* unplugin-vue-components disabled */import { render } from "./details.vue?vue&type=template&id=714b6d6f&scoped=true&ts=true"
import script from "./details.vue?vue&type=script&lang=ts"
export * from "./details.vue?vue&type=script&lang=ts"

import "./details.vue?vue&type=style&index=0&id=714b6d6f&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714b6d6f"]])

export default __exports__